module.exports = __webpack_public_path__ + "img/center-details-data1.ea18c36d.png";